<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('setpwd.setNewLoginPassword') }}
      </div>
    </div>
    <div class="wrap">
      <div class="form-heading">
        {{ $t('setpwd.setNewLoginPassword') }}
      </div>
      <div class="write_box">
        <input
          v-model="password"
          :type="passwordInp"
          :placeholder="$t('setpwd.originalloginpassword')"
        >
        <div
          class="eye_bi"
          :class="passwordInp=='text'?'eye':''"
          @click="showPwd"
        />
      </div>
      <div class="write_new_pwd">
        <div class="write_box">
          <input
            v-model="npassword"
            :type="newpasswordInp"
            :placeholder="$t('setpwd.newpassword')"
          >
          <div
            class="eye_bi"
            :class="newpasswordInp=='text'?'eye':''"
            @click="showNewsPwd"
          />
        </div>
        <div class="write_box">
          <input
            v-model="rpassword"
            :type="newpasswordInp"
            :placeholder="$t('setpwd.confirmnewpassword')"
          >
          <div
            class="eye_bi"
            :class="newpasswordInp=='text'?'eye':''"
            @click="showNewsPwd"
          />
        </div>
      </div>
    </div>
    <div
      v-if="codeStatus"
      class="basic_btn"
      :class="rpassword!=''&&code!=''&&npassword!=''?'':'no_touch'"
      @click="dxRevise"
    >
      {{ $t('setpwd.modify') }}
    </div>
    <div
      v-if="!codeStatus"
      class="basic_btn"
      :class="password!=''&&rpassword!=''&&npassword!=''? '':'no_touch'"
      @click="oldRevise"
    >
      {{ $t('setpwd.modify') }}
    </div>
  </div>
</template>

<script>
    import Vue from 'vue';
    import {
        CountDown,
    } from 'vant';
    import Fetch from '../../utils/fetch'

    Vue.use(CountDown);

    export default {
        name: "Setpwd",
        data() {
            return {
                time: 0,
                oldpwd: '',
                password: '',
                rpassword: '',
                npassword: '',
                mobile: '',
                ycmobile: '',
                passwordInp: 'password',
                newpasswordInp: 'password',
                codeStatus: false,
                codeOK: false,
                code: '',
                is_send: false
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            Fetch('/user/info').then(r => {
                this.mobile = r.data.mobile;
                this.ycmobile = r.data.mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
            })
        },
        methods: {
            cutType(n) {
                n == 1 ? this.codeStatus = true : this.codeStatus = false;
                this.rpassword = '';
                this.npassword = '';
            },
            timeCall() {
                this.is_send = false;
                this.time = 0;
            },
            sendcode() {
                if (this.is_send) {
                    return;
                }
                this.is_send = true;
                Fetch("/index/forgetpwd_email_code", {
                }).then(() => {
                    this.time = 120 * 1000;
                    this.$toast({
                        background: '#07c160',
                        message: this.$t('setpwd.sendsuccessfully')
                    });
                }).catch(() => {
                    this.is_send = false;
                });

            },
            showPwd() {
                this.passwordInp == 'password' ? this.passwordInp = 'text' : this.passwordInp = 'password'
            },
            showNewsPwd() {
                this.newpasswordInp == 'password' ? this.newpasswordInp = 'text' : this.newpasswordInp = 'password'
            },
            dxRevise() {

                if (!this.npassword) {
                    this.$toast(this.$t('setpwd.newpasswordcannotbeempty'));
                    return false;
                }

                if (this.npassword !== this.rpassword) {
                    this.$toast(this.$t('setpwd.inconsistent'));
                    return false;
                }

                Fetch('/index/forgetpwd', {
                    code: this.code,
                    password: this.npassword,
                }).then(() => {

                    this.$toast({
                        background: '#07c160',
                        message: this.$t('setpwd.modifiedsuccessfully')
                    });

                    this.$router.replace('/user')
                });

            },
            oldRevise() {
                if (!this.password) {
                    this.$toast(this.$t('setpwd.originalpasswordcannotbeempty'));
                    return false;
                }
                if (!this.npassword) {
                    this.$toast(this.$t('setpwd.newpasswordcannotbeempty'));
                    return false;
                }
                if (this.npassword !== this.rpassword) {
                    this.$toast(this.$t('setpwd.inconsistent'));
                    return false;
                }
                Fetch('/user/repasswd', {
                    passwd: this.password,
                    npasswd: this.npassword,
                }).then(() => {
                    this.$toast({
                        background: '#07c160',
                        message: this.$t('setpwd.modifiedsuccessfully')
                    });
                    this.$router.replace('/user')
                });
            },
        }
    };
</script>

<style lang="less" scoped>
	
    .no_touch {
        pointer-events: none;
    }

    .wrap {
        padding: 15px 20px 0 20px;
    }

    .title {
        width: 100%;
        height: 25px;
        line-height: 25px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        p {
            font-size: 18px;
            color: #FFFFFF;
            font-weight: 400;
        }

        .cut {
            font-size: 12px;
            color: #3D96FF;
        }
    }

    .bd_tel {
        margin-top: 23px;
        color: #FFFFFF;
        font-size: 14px;
        font-weight: 400;
    }

    .inp_box {
        display: flex;
        justify-content: space-between;
        height: 45px;
        margin-top: 9px;

        .inp {
            width: 195px;
            border: 1px solid rgba(0, 0, 0, 0.1);
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 10px;
            border-radius: 2px;
            background-color: #FFFFFF;

            input {
                width: 100%;
                height: 22px;
                line-height: 22px;
                font-size: 16px;
            }
        }

        .getcode {
            flex: 1;
            margin-left: 10px;
            font-size: 16px;
            text-align: center;
            line-height: 45px;
            color: #FFFFFF;
            height: 45px;
            border-radius: 8px;
			background: linear-gradient(1turn,#36333d, #746b0a);
        }

        .reset_code {
            background: rgba(228, 228, 228, 1);
            color: rgba(0, 0, 0, 0.3);
        }
    }

    .write_box {
        width: 100%;
        height: 45px;
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.1);
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
        border-radius: 2px;
        background-color: #FFFFFF;

        input {
            width: 100%;
            height: 22px;
            line-height: 22px;
            font-size: 16px;
        }
    }

    .eye_bi {
        width: 21px;
        height: 25px;
        background: url(../images/user/eye2.png) no-repeat center center;
        background-size: 100% auto;

        &.eye {
            background: url(../images/user/eye1.png) no-repeat center center;
            background-size: 100% auto;
        }
    }

    .basic_btn {
        margin: 43px auto 0 auto;
    }

    .write_new_pwd {
        margin-top: 32px;

        .write_box:first-child {
            margin-bottom: 18px;
            margin-top: 0px;
        }

        .write_box:last-child {
            margin-top: 0px;
        }
    }

    .basic_wrap {
        box-sizing: border-box;
        min-height: 100vh;
        padding-bottom: 40px;
        background: #f7f5f7 url('../images/ban1/ppbg.png') no-repeat center 56px / 100% auto;
    }

    .red_top_bg {
        height: 56px;
        background: linear-gradient(110deg, #ff4d72, #e31c5f 60%, #bd1e59);
        box-shadow: 0 8px 22px rgba(189, 30, 89, .14);

        .big_tit {
            top: 0;
            width: calc(100% - 108px);
            height: 56px;
            overflow: hidden;
            color: #fff;
            font-size: 17px;
            font-weight: 600;
            line-height: 56px;
            text-align: center;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .back_left {
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        width: 48px;
        height: 56px;
        margin: 0;
        background-size: 20px auto;
        cursor: pointer;
    }

    .wrap {
        box-sizing: border-box;
        margin: 24px 16px 0;
        padding: 22px 18px 24px;
        border: 1px solid #f1e8ed;
        border-radius: 18px;
        background: #fff;
        box-shadow: 0 12px 30px rgba(50, 28, 42, .07);
    }

    .form-heading {
        margin-bottom: 20px;
        padding-left: 12px;
        border-left: 3px solid #e31c5f;
        color: #27232a;
        font-size: 16px;
        font-weight: 700;
        line-height: 1.4;
    }

    .write_new_pwd {
        margin-top: 14px;

        .write_box:first-child {
            margin-bottom: 14px;
        }
    }

    .write_box {
        box-sizing: border-box;
        min-height: 54px;
        height: auto;
        padding: 0 14px;
        border: 1px solid #eae5e9;
        border-radius: 12px;
        background: #faf9fa;
        transition: border-color .2s, background-color .2s;

        &:focus-within {
            border-color: #e31c5f;
            background: #fff;
        }

        input {
            min-width: 0;
            height: 52px;
            border: 0;
            outline: 0;
            background: transparent;
            color: #27232a;
            font-size: 14px;
        }

        input::placeholder {
            color: #99929a;
        }
    }

    .eye_bi {
        flex: 0 0 24px;
        height: 28px;
        margin-left: 10px;
        cursor: pointer;
    }

    .basic_btn {
        box-sizing: border-box;
        width: calc(100% - 32px);
        height: 52px;
        margin: 24px 16px 0;
        border-radius: 13px;
        background: linear-gradient(100deg, #ff4d72, #d82162);
        box-shadow: 0 10px 22px rgba(227, 28, 95, .2);
        color: #fff;
        font-size: 16px;
        font-weight: 600;
        line-height: 52px;
    }

    .basic_btn.no_touch {
        opacity: .5;
        box-shadow: none;
    }

    /* Keep this settings form as compact as the account centre. */
    .red_top_bg {
        height: 50px;

        .big_tit {
            height: 50px;
            font-size: 14px;
            line-height: 50px;
        }
    }

    .back_left {
        width: 44px;
        height: 50px;
        background-size: 14px auto;
    }

    .wrap {
        margin-top: 18px;
        padding: 18px 16px 20px;
        border-radius: 16px;
    }

    .form-heading {
        margin-bottom: 16px;
        padding-left: 10px;
        font-size: 13px;
    }

    .write_new_pwd {
        margin-top: 12px;

        .write_box:first-child {
            margin-bottom: 12px;
        }
    }

    .write_box {
        min-height: 48px;
        padding: 0 12px;
        border-radius: 11px;

        input {
            height: 46px;
            font-size: 12px;
        }
    }

    .eye_bi {
        flex-basis: 18px;
        height: 22px;
        margin-left: 8px;
        background-size: 15px auto;
    }

    .basic_btn {
        height: 48px;
        margin-top: 20px;
        border-radius: 12px;
        font-size: 14px;
        line-height: 48px;
    }
</style>
